import type { ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import { get } from 'lodash-es';

import { Box, Flex } from '../../Core';
import { baseColumn } from './baseColumn';
import type { ColDefFactory, Column } from './types';
import { getStringFormattedColumnComparator } from './utils';

export interface QuoteMarketColumnParams<T extends object = any> {
  isBest?: (data: T | undefined) => boolean;
}

interface QuoteMarketColumnValue {
  market: string | undefined;
  isBest: boolean;
}

export const quoteMarket: ColDefFactory<Column<QuoteMarketColumnParams>> = column => ({
  ...baseColumn(column),
  valueGetter: ({ data }: ValueGetterParams<unknown>): QuoteMarketColumnValue => {
    const market = column.field ? get(data, column.field) : undefined;

    return {
      market,
      isBest: column.params?.isBest?.(data) ?? false,
    };
  },
  valueFormatter: ({ value, context }) => {
    if (value?.market == null) {
      return '';
    }

    return context.current.marketDisplayNameByName?.get(value.market) ?? value.market;
  },
  cellRenderer: ({ value, valueFormatted }: ICellRendererParams<unknown, QuoteMarketColumnValue>) => {
    return (
      <Flex alignItems="center" gap="spacing6">
        {valueFormatted}
        {value?.isBest && (
          <Box px="spacing4" py="spacing2" borderRadius="2px" background="colors.primary.default" data-best-price>
            Best
          </Box>
        )}
      </Flex>
    );
  },
  comparator: getStringFormattedColumnComparator(column),
});
